import type { SVGProps } from "react";

/**
 * chevron-grabber-vertical
 * @category Arrows
 */
export default function IconChevronGrabberVertical(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M8 9.00009L11.2929 5.7072C11.6834 5.31668 12.3166 5.31668 12.7071 5.7072L16 9.00009M16 15.0001L12.7071 18.293C12.3166 18.6835 11.6834 18.6835 11.2929 18.293L8 15.0001'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
